import { Exclude, Expose, instanceToPlain, plainToInstance } from "class-transformer";
import * as t from "io-ts";
import { validateJSON, validateJSONNow } from "../web/validation";
import { Entity } from "./entity";

export const SystemProcessExecutionMetricCodec = t.intersection([
  t.type({
    id: t.string,
    systemProcessExecutionId: t.string,
    metricKey: t.string,
  }),
  t.partial({
    metricValueNumber: t.number,
    metricValueText: t.string,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export type SystemProcessExecutionMetric = t.TypeOf<typeof SystemProcessExecutionMetricCodec>;

@Exclude()
export class SystemProcessExecutionMetricEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  systemProcessExecutionId!: string;

  @Expose()
  metricKey!: string;

  // ─────────────────────────────
  // Optional fields
  // ─────────────────────────────

  @Expose()
  metricValueNumber?: number;

  @Expose()
  metricValueText?: string;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = "SYSPROCEXECMETRIC";

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for SystemProcessExecutionMetricEntity. Recommend using the {@link from} method instead.
   * @hideconstructor
   */
  constructor() {}

  static from(value: SystemProcessExecutionMetric): SystemProcessExecutionMetricEntity {
    return plainToInstance(SystemProcessExecutionMetricEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<SystemProcessExecutionMetric> {
    const object = instanceToPlain(this, { excludeExtraneousValues: true });
    return validateJSON(SystemProcessExecutionMetricCodec, object);
  }

  asTypeValue(): SystemProcessExecutionMetric {
    const object = instanceToPlain(this, { excludeExtraneousValues: true });
    return validateJSONNow(SystemProcessExecutionMetricCodec, object);
  }
}
